import { useEffect, useContext, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../context/auth/AuthContext";
import useTranslator from "../../../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import { haveValue, toast } from "../../../helper/common";
import Canceling from "../../../assets/img/cancel-01.svg";
import EditProfileModal from "../../../components/EditProfileModal";
import { FaRegCircleCheck } from "react-icons/fa6";
import { IoIosCloseCircleOutline } from "react-icons/io";

const LandLordProfile = () => {
  const { _t } = useTranslator();

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { user, changePassword } = authContext;
  const [changePasswordModal, setChangePasswordModal] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("usertype") !== "landlord") navigate("/");
  }, []);

  const defaultPassData = {
    new_password: "",
    confirm_password: "",
    type: localStorage.getItem("usertype"),
  };
  const defaultShowPass = {
    new_password: false,
    confirm_password: false,
  };
  const [showPassword, setShowPassword] = useState(defaultShowPass);
  const [passData, setPassData] = useState(defaultPassData);
  const [pwdErrorMsg, setpwdErrorMsg] = useState("");
  const [passwordChangeLoading, setPasswordChangeLoading] = useState(false);

  const handlePassChange = (e) => {
    setPassData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setpwdErrorMsg("");
  };

  const strongPassword = new RegExp(
    "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
  );

  const [focused, setFocused] = useState(false);
  const [allPassed, setAllPassed] = useState(false);

  const passwordChecks = useMemo(() => {
    const pwd = passData.new_password || "";
    return {
      length: pwd.length >= 8,
      upper: /[A-Z]/.test(pwd),
      lower: /[a-z]/.test(pwd),
      number: /\d/.test(pwd),
      special: /[!@#$%^&*(),.?":{}|<>_]/.test(pwd),
    };
  }, [passData.new_password]);

  useEffect(() => {
    const passed = Object.values(passwordChecks).every(Boolean);

    if (passed && focused) {
      setAllPassed(true);
      setFocused(false);
    } else if (!passed && allPassed) {
      setAllPassed(false);

      const activeElement = document.activeElement;
      if (activeElement?.name === "new_password") {
        setFocused(true);
      }
    }
  }, [passwordChecks, focused, allPassed]);

  const renderCheck = (condition, text) => (
    <div className={`rule-item ${condition ? "passed" : ""}`}>
      {condition ? (
        <FaRegCircleCheck size={14} />
      ) : (
        <IoIosCloseCircleOutline size={14} />
      )}
      <span className="rule-text">{text}</span>
    </div>
  );

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (passData.new_password === "" || passData.confirm_password === "") {
      setpwdErrorMsg(_t("pleaseEnterAllFields"));
    } else if (passData.new_password !== passData.confirm_password) {
      setpwdErrorMsg(_t("passwordNotMatches"));
    } else if (!strongPassword.test(passData.new_password)) {
      setpwdErrorMsg(
        _t("pleaseIncludeUppercaseLowercaseAndSpecialCharactersInYourPassword")
      );
    } else {
      setpwdErrorMsg("");
      setPasswordChangeLoading(true);
      changePassword(passData, user?._id)
        .then((res) => {
          console.log(res, "CHECK TEH VAL HERE");
          if (res) {
            toast.success(_t("Password Changed!"));
            setChangePasswordModal(false);
            setPassData(defaultPassData);
            setShowPassword(defaultShowPass);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setPasswordChangeLoading(false);
        });
    }
  };

  const handleShowPassword = async (type) => {
    setShowPassword((prev) => ({ ...prev, [type]: !prev[type] }));
  };
  const [showProfileModal, setShowProfileModal] = useState(false);

  return (
    <>
      <div className="landlord-profile-main">
        <div className="landlord-profile-comp">
          <div className="landlord-header">
            <div className="landlord-header-name">
              {user?.fname_companyName &&
                user?.fname_companyName.charAt(0).toUpperCase()}
              {user?.lname && user?.lname.charAt(0).toUpperCase()}
            </div>
          </div>
          <div className="landlord-profile-content">
            <h4 className="landlord-name">
              {user?.fname_companyName}, <span>{user?.lname}</span>
            </h4>
            <div className="landlord-info">
              <div className="info">
                <h4>{_t("phoneNumber")}</h4>
                <h3>{user?.phone}</h3>
              </div>
              <div className="info">
                <h4>{_t("email")}</h4>
                <h3>{user?.email}</h3>
              </div>
              <div className="info">
                <h4>{_t("linkedInUrl")}</h4>
                <h3>{user?.cif_dni_nie}</h3>
              </div>
            </div>
            <div className="landlord-profile-btn">
              <button onClick={(e) => setChangePasswordModal(true)}>
                <img src="/images/change-password.svg" />
                {_t("changePassword")}
              </button>
              <button
                className="dark-btn"
                onClick={() => setShowProfileModal(true)}
              >
                <img src="/images/edit-profile.svg" />
                {_t("Edit Profile")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <EditProfileModal
        show={showProfileModal}
        onClose={() => setShowProfileModal(false)}
      />

      <Modal
        show={changePasswordModal}
        onHide={(e) => setChangePasswordModal(false)}
        centered
        className="newmodalui wrapper-modal landlord-changePassword-modal"
      >
        <Modal.Header>
          <Modal.Title>{_t("changePassword")}</Modal.Title>
          <div
            className="cursor-pointer"
            onClick={(e) => setChangePasswordModal(false)}
          >
            <img
              src={Canceling}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleChangePassword}>
            <div className="auth-form">
              <div className="forminput customInput">
                <label className="forminput input-text">
                  {_t("newPassword")}
                </label>
                <div className="input-with-eye">
                  <input
                    type={showPassword?.new_password ? "text" : "password"}
                    name="new_password"
                    placeholder={_t("enterPassword")}
                    onChange={handlePassChange}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                  />
                  {showPassword?.new_password ? (
                    <VscEye
                      className="eye-icons-reset"
                      onClick={(e) => handleShowPassword("new_password")}
                    />
                  ) : (
                    <VscEyeClosed
                      className="eye-icons-reset"
                      onClick={(e) => handleShowPassword("new_password")}
                    />
                  )}
                </div>
                {focused && (
                  <div className="errorPopup">
                    {renderCheck(
                      passwordChecks.upper,
                      "At least one uppercase letter"
                    )}
                    {renderCheck(
                      passwordChecks.lower,
                      "At least one lowercase letter"
                    )}
                    {renderCheck(passwordChecks.number, "At least one number")}
                    {renderCheck(
                      passwordChecks.special,
                      "At least one special character"
                    )}
                    {renderCheck(
                      passwordChecks.length,
                      "Minimum 8 characters long"
                    )}
                  </div>
                )}
              </div>
              <div
                className={`forminput customInput ${
                  haveValue(pwdErrorMsg) ? "error-field" : ""
                }`}
              >
                <label className="forminput input-text">
                  {_t("reEnterNewPassword")}
                </label>
                <div className="input-with-eye">
                  <input
                    type={showPassword?.confirm_password ? "text" : "password"}
                    name="confirm_password"
                    placeholder={_t("enterPassword")}
                    onChange={handlePassChange}
                  />
                  {showPassword?.confirm_password ? (
                    <VscEye
                      className="eye-icons-reset"
                      onClick={(e) => handleShowPassword("confirm_password")}
                    />
                  ) : (
                    <VscEyeClosed
                      className="eye-icons-reset"
                      onClick={(e) => handleShowPassword("confirm_password")}
                    />
                  )}
                </div>
              </div>
              <div className="w-100">
                {haveValue(pwdErrorMsg) && (
                  <label className="forminput password_error error-message">
                    {pwdErrorMsg}
                  </label>
                )}
                <button
                  disabled={passwordChangeLoading}
                  className="btnNext change-password-btn w-100"
                  type="submit"
                >
                  {_t("changePassword")}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LandLordProfile;
